import Choices from 'choices.js';

const defaultOptions = {
  renderSelectedChoices: false,
  shouldSort: false,
};

const initChoicesInstance = (el, options) => {
  return new Choices(el, { ...defaultOptions, ...options });
};

export default initChoicesInstance;
